import React from 'react';
import { isMobile } from 'react-device-detect';
import styled, { css } from 'styled-components';
import { FlexBox, Heading2, Heading4 } from '@docon/docon-ui-library';
import Image from 'shared/Image';
import { colors } from 'utilities/colorConfig';

const Root = styled(FlexBox)`
  max-width: 320px;
  margin: auto;
  flex-direction: column;
  justify-content: center;

  ${Image} {
    margin-bottom: 30px;
  }

  ${Heading4} {
    margin: 16px auto 40px;
    color: ${colors.subHeading};
  }

  ${() => isMobile && css`
    ${Image} {
      margin: 20px auto;
      width: unset;
    }

    ${Heading2} {
      font-size: 18px;
      line-height: 26px;
    }

    ${Heading4} {
      font-size: 14px;
      line-height: 18px;
      margin: 10px 24px auto;
    }
  `}
`;

export interface IProps {
  image: string;
  title: string;
  description: string;
}

function CustomSlide({
  image,
  title,
  description,
}: IProps) {

  return (
    <Root>
      <Image src={image} alt='' />
      <Heading2 fontWeight={700} title={title} />
      <Heading4 title={description} />
    </Root>
  );
}

export default CustomSlide;